// assets
import { 
    IconShip,
    IconArrowAutofitContent,
    IconAd2,
    IconCalculator,
    IconSettings2,
    Icon24Hours,
    IconTruckReturn
} from '@tabler/icons';

import SecurityService from "services/SecurityService";
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const reports = {
    id: 'reports',
    title: 'Reports',
    type: 'collapse',
    children: []
};

if (SecurityService.userIsGrantedTo('ships_monitoring')) {
    reports.children.push({
        id: 'ships_monitoring',
        title: 'Ships monitoring',
        type: 'item',
        url: '/ships_monitoring',
        icon: IconShip,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('cargo_status')) {
    reports.children.push({
        id: 'cargo_status',
        title: 'Cargo status',
        type: 'item',
        url: '/cargo_status',
        icon: IconArrowAutofitContent,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('inventory_records')) {
    reports.children.push({
        id: 'inventory',
        title: 'Inventory',
        type: 'item',
        url: '/inventory',
        icon: IconAd2,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('total_entries')) {
    reports.children.push(
        {
            id: 'total_entries',
            title: 'Total entries by Date range',
            type: 'item',
            icon: IconCalculator,
            breadcrumbs: false,
            url: '/total_entries'
        },
        {
            id: 'total_entries_month',
            title: 'Total entries in Current month',
            type: 'item',
            icon: IconCalculator,
            breadcrumbs: false,
            url: '/total_entries_month'
        },
        {
            id: 'total_entries_year',
            title: 'Total entries in Current year',
            type: 'item',
            icon: IconCalculator,
            breadcrumbs: false,
            url: '/total_entries_year'
        }
    );
}

if (SecurityService.userIsGrantedTo('flexible_reports')) {
    reports.children.push({
        id: 'flexible_reports',
        title: 'Flexible reports',
        type: 'item',
        url: '/flexible_reports',
        icon: IconSettings2,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('emanifest_monitoring_stats')) {
    reports.children.push({
        id: 'emanifest_monitoring_stats',
        title: 'EMainfest monitoring statistics',
        type: 'item',
        url: '/emanifest_monitoring_stats',
        icon: Icon24Hours,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('crossing_bill_of_ladings')) {
    reports.children.push({
        id: 'crossing_bill_of_ladings',
        title: 'Crossing Bill of Ladings',
        type: 'item',
        url: '/crossing_bill_of_ladings',
        icon: IconTruckReturn,
        breadcrumbs: false
    });
}

export default reports;
